import type { SVGProps } from "react";

export function IconBlueTarget(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect width="56" height="56" rx="28" fill="#F0F4F7" />
      <g clipPath="url(#clip0_2665_14703)">
        <circle
          cx="28.0003"
          cy="28.0001"
          r="13.3333"
          fill="#63B2FF"
          stroke="#63B2FF"
          strokeWidth="2"
          strokeLinecap="square"
        />
        <path
          d="M28 14.6667V41.3334"
          stroke="black"
          strokeWidth="2"
          strokeLinecap="square"
        />
        <path
          d="M18.5723 18.572L37.4284 37.4282"
          stroke="black"
          strokeWidth="2"
          strokeLinecap="square"
        />
        <path
          d="M41.333 28L14.6663 28"
          stroke="black"
          strokeWidth="2"
          strokeLinecap="square"
        />
        <path
          d="M37.4277 18.572L18.5716 37.4282"
          stroke="black"
          strokeWidth="2"
          strokeLinecap="square"
        />
      </g>
      <defs>
        <clipPath id="clip0_2665_14703">
          <rect
            width="32"
            height="32"
            fill="white"
            transform="translate(12 12)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
